const config = {
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_BESaB3lKZ',
    APP_CLIENT_ID: '36kad9b6v31sd9u74o14p4mqul',
    IDENTITY_POOL_ID: 'us-east-1:db240c14-2a7c-4d0d-b25b-a2235cfaca26',
  }
};
export default config;